import { StateCreator } from "zustand";

import { getDevice } from "../../helpers/detectDevice";
import { Device, GeolocationData, LoginData } from "../../types/common";
import { StoreMiddlewares } from "../storeTypes";

export type UserDataSliceState = {
  device: Device;
  geolocation: GeolocationData;
  isContinuingWatching: boolean;
  loginData: LoginData;
  vsId: string | undefined;
};

type UserDataSliceActions = {
  setGeolocation: (geolocation: GeolocationData) => void;
  setLoginData: (loginData: LoginData) => void;
  setVsId: (uuId: string | undefined) => void;
};

export type UserDataSlice = UserDataSliceState & UserDataSliceActions;

export const USER_DATA_SLICE_DEFAULTS: UserDataSliceState = {
  device: getDevice(),
  geolocation: {
    countryCode: "FI",
    isPortabilityRegion: true
  },
  isContinuingWatching: false,
  loginData: {
    loggedIn: false,
    residenceInFinland: false,
    userId: undefined
  },
  vsId: undefined // For Adobe analytics
};

export const userDataSlice: StateCreator<
  UserDataSlice,
  StoreMiddlewares
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
> = set => ({
  ...USER_DATA_SLICE_DEFAULTS,
  setGeolocation: geolocation => set({ geolocation }, false, "setGeolocation"),
  setLoginData: loginData => set({ loginData }, false, "setLoginData"),
  setVsId: vsId => set({ vsId }, false, "setVsId")
});
